const alertValidationErrors = (errors) => {
  let message = 'There was an error updating your information.<ul>';

  Object.keys(errors).forEach((key) => {
    let field_errors = errors[key];
    field_errors.forEach((error) => {
      message += '<li>' + error + '</li>';
    });
  });

  message += '</li>';
  notyf.error({
    dismissible: true,
    message: message,
    ripple: true,
    duration: 5000,
  });
};

const genericError = () => {
  notyf.error('There was an error. Please try again later');
};

const saveSuccess = () => {
  notyf.success('Save successful');
};

export { alertValidationErrors, genericError, saveSuccess };
